var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaterialPaint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_784_556)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#F5F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5224 15L16.0068 15.5156L17.3977 16.9065L15.1315 19.1741C14.9476 19.3562 14.8557 19.5817 14.8557 19.8509C14.8557 20.12 14.9476 20.3455 15.1315 20.5276L17.2658 22.6619C17.4496 22.8457 17.6655 22.9377 17.9133 22.9377C18.1611 22.9377 18.3769 22.8457 18.5607 22.6619L20.695 20.5276C20.8789 20.3457 20.9708 20.1204 20.9708 19.8516C20.9708 19.5828 20.8776 19.3553 20.6913 19.1689L16.5224 15Z",
    fill: "#0D0A19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3545 22.8879C21.5224 23.057 21.7254 23.1415 21.9635 23.1415C22.2016 23.1415 22.4054 23.057 22.575 22.8879C22.7446 22.7188 22.8293 22.5156 22.8293 22.2782C22.8293 22.1395 22.7974 21.9909 22.7334 21.8324C22.6695 21.674 22.5815 21.5108 22.4696 21.3429C22.4057 21.239 22.3277 21.1271 22.2358 21.0072C22.1439 20.8873 22.054 20.7754 21.966 20.6715C21.8781 20.7754 21.7882 20.8873 21.6962 21.0072C21.6043 21.1271 21.5264 21.239 21.4624 21.3429C21.3505 21.5108 21.2626 21.674 21.1986 21.8324C21.1347 21.9909 21.1027 22.1395 21.1027 22.2782C21.1027 22.5156 21.1866 22.7188 21.3545 22.8879Z",
    fill: "#0D0A19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 33V25.5H22.5V33H15ZM16.5 31.5H21V27H16.5V31.5ZM25.5 22.5V15H33V22.5H25.5ZM27 21H31.5V16.5H27V21ZM25.5 33V25.5H33V33H25.5ZM27 31.5H31.5V27H27V31.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_784_556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialPaint);
export default __webpack_public_path__ + "static/media/material-paint.87bf264712fc5eb8ccc740324dfb80bb.svg";
export { ForwardRef as ReactComponent };